var storeDateTimeNow = '2025-06-30 08:56';
if(typeof(chatbot) === 'undefined'){
  var chatbot = {
      settings:{
        workingHours:{
          weekdays:'9:00-19:00',
          saturday:'11:00-16:00',
          sunday:'',
          holidays:''
        }
      },
      private:{
        getTodayInEST: function(){
          const currentDate = new Date();
          const formattedDate = currentDate.toLocaleString('en-US', { timeZone: 'America/New_York' });

          return new Date(formattedDate);
        },
        getCurrentTime: function(){
          try{
            return new Date(storeDateTimeNow);
          }catch(ex){
            console.error(ex);
          }
        },
        getHolidays: function(){
          let datesArray = [];
          let dateStrings = chatbot.settings.workingHours.holidays.split(',');
          for(let i in dateStrings){
            let convertedDate =new Date(dateStrings[i]);
            if(convertedDate.toString() !== 'Invalid Date') datesArray.push(convertedDate);
          }

          return datesArray;
        },
        getWeekdayName: function(date){
          switch(date.getDay()){
            case 0:
              return 'Sun';
            case 1:
              return 'Mon';
            case 2:
              return 'Tue';
            case 3:
              return 'Wed';
            case 4:
              return 'Thu'
            case 5:
              return 'Fri'
            case 6:
              return 'Sat'
            default:
              return 'Invalid';

          } 
        },
        isHoliday: function(now){
          let holidays = chatbot.private.getHolidays();
          for(let i in holidays){
            if(chatbot.private.isSameDate(now,holidays[i])) return true;
          }
          return false;
        },
        isInWorkingHours: function(today){
          let weekday = chatbot.private.getWeekdayName(today);
          if(weekday === 'Mon' || weekday === 'Tue' || weekday === 'Wed' || weekday === 'Thu' || weekday === 'Fri'){
            return chatbot.private.isInTimeRange(today,chatbot.settings.workingHours.weekdays);
          }else if(weekday === 'Sat'){
            return chatbot.private.isInTimeRange(today,chatbot.settings.workingHours.saturday);
          }else{
            return chatbot.private.isInTimeRange(today,chatbot.settings.workingHours.sunday);
          }
        },
        isInTimeRange: function(today,workingHours){
          var hoursList = workingHours.split('-');
          if(hoursList.length < 2) return false;

          var beginTimeString = hoursList[0];
          var endTimeString = hoursList[1];
          var beginTime = chatbot.private.getTodayInEST().setHours(beginTimeString.split(':')[0],beginTimeString.split(':')[1]);
          var endTime = chatbot.private.getTodayInEST().setHours(endTimeString.split(':')[0],endTimeString.split(':')[1]);

          return (beginTime <= today.getTime() && today.getTime() <= endTime);


        },
        isInWeekdaysWorkingHours:function(today){
          var weekdaysHoursList = chatbot.settings.workingHours.weekdays.split('-');
          if(weekdaysHoursList.length < 2) return false;
          var beginTimeString = weekdaysHoursList[0];
          var endTimeString = weekdaysHoursList[1];
          var beginTime = new Date(storeDateTimeNow).setHours(beginTimeString.split(':')[0],beginTimeString.split(':')[1]);
          var endTime = new Date(storeDateTimeNow).setHours(endTimeString.split(':')[0],endTimeString.split(':')[1]);

          return (beginTime <= today.getTime() && today.getTime() <= endTime);
        },
        isSameDateAlt: function(firstDate,secondDate){
          if(firstDate.getFullYear() !== secondDate.getFullYear()) return false;
          if(firstDate.getMonth() !== secondDate.getMonth()) return false;
          if(firstDate.getDate() !== secondDate.getDate()) return false;

          return true;

        },
        isSameDate: function(firstDate,secondDate){
          return firstDate.toLocaleDateString() === secondDate.toLocaleDateString();
        }
      },
      isWorkingTime: function(){
        let today = chatbot.private.getTodayInEST();
        if(chatbot.private.isHoliday(today)) return false;
        if(!chatbot.private.isInWorkingHours(today)) return false;
        return true;
      },
      showOffline: function(){
        $('body').append("<div class='offlineIcon'><span class='tooltiptext'></span></div>");
        $('.tooltiptext').html(`<p>The chat is currently offline.</p>`);

        $('.offlineIcon').click(function(){
          $('.tooltiptext').addClass('showTip');
        });

        $('.offlineIcon').mouseleave(function(){
          $('.tooltiptext').removeClass('showTip');
        });
      }
  }
}
$(window).click("textarea.chasitorText", function (e) {
  if (e.offsetX > $("textarea.chasitorText").width()) {
    const keyboardEvent = new KeyboardEvent("keydown", {
      code: "Enter",
      key: "Enter",
      charCode: 13,
      keyCode: 13,
      view: window,
      bubbles: true,
    });

    $("textarea.chasitorText")[0].dispatchEvent(keyboardEvent);
  }
});
$('.embeddedServiceHelpButton').on('click','div.embeddedServiceHelpButton button.uiButton.helpButtonEnabled span.embeddedServiceIcon',
  function (e) {
    console.log(e);
    if (e.target.localName != "button" && e.target.localName != "span") return;
    $("svg#ezGVUS6sedq1").appendTo("div.helpButton");
    $("svg#ezGVUS6sedq1").show();
    $("button.uiButton.helpButtonEnabled").hide();
    setTimeout(function () {
      //$('button.uiButton.helpButtonEnabled').css('opacity','1.0');

      $("svg#ezGVUS6sedq1").hide();
      $("button.uiButton.helpButtonEnabled").show();
    }, 4000);
  }
);
$(window).blur("button.uiButton.helpButtonEnabled", function () {
  $("button.uiButton.helpButtonEnabled").css("opacity", "1.0");
});


